import React from "react";

const TeamMember = ({ teamMember }) => {
  const avatar = teamMember?.avatar;
  return (
    <>
      <div className="checkbox-container">
        <img alt={teamMember.name} src={avatar} className="team-avater" />
        <p className="label">{teamMember.name}</p>
      </div>
    </>
  );
};

export default TeamMember;
